import React from "react";
import { useTheme } from "@mui/material";

interface DeveloperTrackIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const DeveloperTrackIcon: React.FC<DeveloperTrackIconProps> = ({
  width = 48,
  height = 48,
  color,
}) => {
  const theme = useTheme();
  const iconColor = color || theme.nawy.colors.semantic.text.tertiary;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Document Icon */}
      <rect
        x="10"
        y="6"
        width="28"
        height="36"
        rx="3"
        stroke={iconColor}
        strokeWidth="2"
        fill="none"
      />
      {/* Fold Corner */}
      <path
        d="M28 6V14H38"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M28 6L38 14"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Lines on document */}
      <line
        x1="16"
        y1="22"
        x2="32"
        y2="22"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="16"
        y1="28"
        x2="28"
        y2="28"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="16"
        y1="34"
        x2="24"
        y2="34"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default DeveloperTrackIcon;
